export const CANONICAL_PUBLIC_HOST = 'https://www.s-shot.ru';
export const LEGAL_DOCUMENT_VERSION = '2026-03-25';
export const PRIVACY_LEGAL_DOCUMENT_VERSION = '2026-05-07';

export type LegalDocumentKey =
  | 'offer'
  | 'privacy'
  | 'terms'
  | 'personalDataProcessingConsent';

export type RecurringConsentSource = 'pricing' | 'billing_confirm';

export interface LegalDocumentReference {
  key: LegalDocumentKey;
  slug: string;
  title: string;
  path: string;
  version: string;
}

export interface LegalDocumentEvidence {
  slug: string;
  version: string;
  url: string;
}

export const LEGAL_DOCUMENTS: Record<LegalDocumentKey, LegalDocumentReference> = {
  offer: {
    key: 'offer',
    slug: 'offer',
    title: 'Публичная оферта',
    path: '/offer',
    version: LEGAL_DOCUMENT_VERSION,
  },
  privacy: {
    key: 'privacy',
    slug: 'privacy',
    title: 'Политика конфиденциальности',
    path: '/privacy',
    version: PRIVACY_LEGAL_DOCUMENT_VERSION,
  },
  terms: {
    key: 'terms',
    slug: 'terms',
    title: 'Пользовательское соглашение',
    path: '/terms',
    version: LEGAL_DOCUMENT_VERSION,
  },
  personalDataProcessingConsent: {
    key: 'personalDataProcessingConsent',
    slug: 'personal-data-processing-consent',
    title: 'Согласие на обработку персональных данных',
    path: '/personal-data-processing-consent',
    version: LEGAL_DOCUMENT_VERSION,
  },
};

export const LEGAL_LINKS = [
  LEGAL_DOCUMENTS.offer,
  LEGAL_DOCUMENTS.privacy,
  LEGAL_DOCUMENTS.terms,
  LEGAL_DOCUMENTS.personalDataProcessingConsent,
] as const;

export const RECURRING_CONSENT_TEXT =
  'Я согласен на автоматические списания согласно условиям оферты';

function joinUrl(baseUrl: string, path: string): string {
  return `${baseUrl.replace(/\/+$/, '')}${path}`;
}

export function buildLegalDocumentEvidence(
  baseUrl: string = CANONICAL_PUBLIC_HOST,
): Record<LegalDocumentKey, LegalDocumentEvidence> {
  return {
    offer: {
      slug: LEGAL_DOCUMENTS.offer.slug,
      version: LEGAL_DOCUMENTS.offer.version,
      url: joinUrl(baseUrl, LEGAL_DOCUMENTS.offer.path),
    },
    privacy: {
      slug: LEGAL_DOCUMENTS.privacy.slug,
      version: LEGAL_DOCUMENTS.privacy.version,
      url: joinUrl(baseUrl, LEGAL_DOCUMENTS.privacy.path),
    },
    terms: {
      slug: LEGAL_DOCUMENTS.terms.slug,
      version: LEGAL_DOCUMENTS.terms.version,
      url: joinUrl(baseUrl, LEGAL_DOCUMENTS.terms.path),
    },
    personalDataProcessingConsent: {
      slug: LEGAL_DOCUMENTS.personalDataProcessingConsent.slug,
      version: LEGAL_DOCUMENTS.personalDataProcessingConsent.version,
      url: joinUrl(baseUrl, LEGAL_DOCUMENTS.personalDataProcessingConsent.path),
    },
  };
}
